import React, { useRef, useCallback, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Webcam from 'react-webcam';
import Swal from 'sweetalert2';

const CaptureModal = ({showCaptureModal, closeCaptureModal, handleChildData}) => {
  const webcamRef = useRef(null);
  const [btnStatus, setBtnStatus] =useState(false);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    // You can return the captured data here
    setBtnStatus(true)
    return imageSrc;
  }, []);

  const sendDataToParent = () => {
    // Invoke the function passed from the parent with the capture function
    handleChildData(capture);
    Swal.fire({
      icon: 'success',
      title: 'Image is saved',
      text: 'Photo han been saved successfully!',
      preConfirm: () => {
        closeCaptureModal();
      }
    });
  };

  return (
    <div>
            <Modal show={showCaptureModal} onHide={closeCaptureModal}>
            <Modal.Header closeButton>
                <Modal.Title>Photo Capture</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="col-xl-12">
                    <Webcam
                            audio={false}
                            height={500}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width={450}
                        />    
                </div>
                <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <Button variant="primary" onClick={capture}>
                      Snap it
                    </Button>
                    <span className='p-1'></span>
                    <Button variant="success" onClick={sendDataToParent} disabled={!btnStatus}>
                      Save Image
                    </Button>
                </div>
              </Modal.Body>
            </Modal>
    </div>
  )
}

export default CaptureModal
